import Url from "url-parse";

import config from "../config";

export default function parseUrlWithBaseHost(url) {
  const defaultBaseUrl = `https://${config.baseHostName}`;
  return new Url(url, defaultBaseUrl);
}
